<template>
	<div class="container">
		<div
			 v-for="(item, index) in data.data ?? []">
			<highlighted-block-card-no-image
					v-if="parseInt(item.type) === HighlightedBlockComponentType.NO_IMAGE"
					:data="item"
			/>
			<highlighted-block-card-image
					v-if="parseInt(item.type) !== HighlightedBlockComponentType.NO_IMAGE"
					:data="item"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {PageComponentClass, PageComponentInterface} from "../Interfaces/PageComponentInterface";
import HighlightedBlockCardNoImage from "../../../Components/HighlightedBlock/HighlightedBlockCardNoImage.vue";
import HighlightedBlockCardImage from "../../../Components/HighlightedBlock/HighlightedBlockCardImage.vue";
import {HighlightedBlockComponentTypeEnum} from "../Enums/HighlightedBlockComponentTypeEnum";

export default defineComponent({
	name: "HighlightedBlockPageSection",
	components: {
		HighlightedBlockCardImage,
		HighlightedBlockCardNoImage
	},
	computed: {
		HighlightedBlockComponentType() {
			return HighlightedBlockComponentTypeEnum;
		}
	},
	props: {
		data: {
			type: Object as PropType<PageComponentInterface>,
			default: new PageComponentClass(),
			required: true,
		}
	}
});
</script>

<style scoped>
:deep(table), :deep(td), :deep(tr) {
	border: 1px solid;
}
:deep(ul) {
	list-style: initial;
	padding-left: 20px;
}
:deep(ol) {
	list-style: decimal;
	padding-left: 20px;
}
</style>
